import React from 'react';
import PropTypes from 'prop-types';
import Behavior from './Behavior';
import Cognitive from './Cognitive';
import Interest from './Interest';
import Distortion from './Distortion';

const DimensionMatchResult = (props) => {
  const {
    respondent, jobProfile, behaviorMatch, distortionResults, cognitiveMatch, interestMatch,
  } = props;

  let behavior = null;
  let distortion = null;
  if (behaviorMatch) {
    behavior = <Behavior behavior={behaviorMatch} />;
    distortion = <Distortion distortion={distortionResults} />;
  }
  let cognitive = null;
  if (cognitiveMatch) {
    cognitive = <Cognitive cognitive={cognitiveMatch} />;
  }

  let interest = null;
  if (interestMatch) {
    interest = <Interest respondent={respondent} jobProfile={jobProfile} interest={interestMatch} />;
  }

  return (
    <div>
      {behavior}
      {distortion}
      {cognitive}
      {interest}
    </div>
  );
};

DimensionMatchResult.propTypes = {
  jobProfile: PropTypes.objectOf(PropTypes.any).isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  behaviorMatch: PropTypes.objectOf(PropTypes.any).isRequired,
  distortionResults: PropTypes.objectOf(PropTypes.any).isRequired,
  cognitiveMatch: PropTypes.objectOf(PropTypes.any).isRequired,
  interestMatch: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DimensionMatchResult;
